import type { SvelteComponent } from "svelte"
import PredefinedBlock from "./PredefinedBlock.svelte"
import Columns from "./Columns.svelte"
import ProductListPreviewWidget from "../product/ProductListPreviewWidget.svelte"

const blocks: {
    [key: string]: {
        sectionClass: string
        component: typeof SvelteComponent<{ block?: ContentBlock }>
    }
} = {
    default: {
        sectionClass: "",
        component: Columns,
    },
    columns: {
        sectionClass: "",
        component: Columns,
    },

    predefinedBlock: {
        sectionClass: "predefined-block",
        component: PredefinedBlock,
    },
    productSlider: {
        sectionClass: "",
        component: ProductListPreviewWidget,
    },
}

export default blocks
